import React from 'react';
import { openIntercomWindow } from '@gik/core/utils/Intercom';
import ContactTile from '@gik/contact/components/ContactTile/ContactTile';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '@gik/contact/i18n/en';
import { HTMLParser } from '@gik/ui';

export default function Chat() {
  const bem = useBemCN('live-support');
  const { t } = useTranslation();

  function onButtonClicked() {
    openIntercomWindow();
  }

  return (
    <ContactTile
      {...bem()}
      title={t(translationKeys.LiveSupportTitle)}
      buttonText={t(translationKeys.LiveSupportButtonText)}
      buttonAction={onButtonClicked}
    >
      <>
        {/* TODO: we can use better translations by setting up the times as moment objects */}
        <HTMLParser rawHtml={t(translationKeys.LiveSupportTimes)} />
      </>
    </ContactTile>
  );
}
